// import { push } from 'connected-react-router'
import { useState } from 'react'
import { strJSX } from "../../app/utils"
import './BLTReviewForm.styles.scss'

const BLTChangeReviewForm = (props) => {
    const {
        data, 
        isReadOnly, 
        // review, 
        showChangesTitle, 
        // reviewKey, 
        showConfirmation, 
        confirmationMessage} = props
    let elements = []

    //const [itemReview, setItemReview] = useState((data && ("review" in data)) ? data.review : review)
    const [finalConfirmation, setFinalConfirmation] = useState(null)

    const commonParameters = {
        "name" : "Name",
        "homeAddress" : "Home address",
        "firstName" : "First name",
        "lastName" : "Last name",
        "phoneNumber" : "Phone number",
        "phone" : "Phone",
        "alternatePhone" : "Alternate phone",
        "email" : "Email",
        "emailAddress" : "Email address",
        "city" : "City",
        "streetAddress" : "Street address",
        "street" : "Street address", 
        "pin" : "PIN code",
        "postalCode" : "Postal code",
        "province" : "Province",
        "country" : "Country",
        "number" : "Number",
        "people" : "Name",
        "dateOfOffence" : "Date of offence",
        "description" : "Description",
        "businessLicenceType" : "Business type",
        "suspensionDate" : "Suspension date",
        "reason" : "Reason",
        "action" : "Action",
        "registryId" : "Registry ID",
        "compnayTrademark" : 'Trademark',
        "legalName" : "Legal name",
        "operatingName" : "Operating name",
        "businessAddress" : "Business address",
        "serviceAddress" : "Address for service",
        "civicAddress" : "Civic address",
        "financialAddress" : "Financial records location",
        "rjscOfficials" : "Officials with RJSC",
        "complianceOfficer" : "Compliance officer",
        "mainBusinessContact" : "Business contact",
        "responsibleAgent" : "Responsible agent",
        "companyType" : "Company type",
        "branchName" : "Branch name",
        "accountNumber" : "Account number",
        "address" : "Address",
        "signingOfficers" : "Signing officers",
        "tradeMark" : "Company trademark"
    }

    // useEffect(() => {
    //     setItemReview((data && ("review" in data)) ? data.review : review)
    // }, [data, review])
    
    const onSectionItemFail = (key, parameterName) => { 
        if(Array.isArray(data)) {
            let nextStatus = ""

            if(data[key]["review"] !== "incomplete")
                nextStatus = "incomplete"
            else 
                nextStatus = null
            //data.splice(parseInt(key),1,{...data[key], review: "complete"})
            props.onStatusChange({
                ...data[key],
                review : nextStatus
            })
        }
    }

    const onSectionItemPass = (key, parameterName) => {
        if(Array.isArray(data)) {
            let nextStatus = ""
            if(data[key]["review"] !== "complete")
                nextStatus = "complete"
            else 
                nextStatus = null

            //data.splice(parseInt(key),1,{...data[key], review: "complete"})
            props.onStatusChange({
                ...data[key],
                review : nextStatus
            })
        }
    }

    const onConfirmationFail = () => {
        setFinalConfirmation("incomplete")
    }

    const onConfirmationPass = () => {
        setFinalConfirmation("complete")
    }


    if(showChangesTitle) { 
        elements.push(
            <div key={"data-review-title"} className="row bottomMarginNormal bltReviewFormItem">
                <div className={"col-lg-2 hideOverflow"}>
                    &nbsp;
                </div>
                <div className={"col-lg-4 hideOverflow"}>
                    <b>Current record</b>
                </div>
                <div className={"col-lg-4 hideOverflow"}>
                    <b>Requested change</b>
                </div>
            </div>
        )
    }

    const pushChangeFormItem = (key,change) => {
        const {
            parameterName, 
            changeFrom, 
            changeTo, 
            review, 
            forceSelection
        } = change;

            const isChanged = (changeFrom !== changeTo)

            elements.push(
                <div key={"data-review-"+key+parameterName} className="row bottomMarginNormal bltReviewFormItem">
                    <div className={"col-lg-2 hideOverflow"}>
                        <b>{commonParameters[parameterName] ?? parameterName}</b>
                    </div>
                    <div className={"col-lg-4 hideOverflow"}>
                        {strJSX(changeFrom)}
                    </div>
                    <div className={`col-lg-4 hideOverflow ${isChanged ? "change" : ""}`}>
                        {isChanged ? strJSX(changeTo) : ""}
                    </div>
                    {(forceSelection || isChanged) && 
                    <div className={"col-lg-2"} style={{textAlign:"end"}}>
                        <button 
                            key={`${parameterName}-fail`}
                            id={`${parameterName}-fail`}
                            className={"bltReviewFormItemCheckMark" + (review === "incomplete" ? " bltReviewFormItemCheckMarkFail" : "")} 
                            onClick={() => onSectionItemFail(key, parameterName)}
                            disabled={isReadOnly}
                        >
                            <i className="fa fa-2x fa-times-circle"></i>
                        </button>
                        <button
                            key={`${parameterName}-pass`} 
                            id={`${parameterName}-pass`}
                            className={"bltReviewFormItemCheckMark" + (review === "complete" ? " bltReviewFormItemCheckMarkPass" : "")} 
                            onClick={() => onSectionItemPass(key, parameterName)}
                            disabled={isReadOnly}
                        >
                            <i className="fa fa-2x fa-check-circle"></i>
                        </button>
                    </div>}
                </div>
            )
    }

    for (const key in data) {
        if (Object.hasOwnProperty.call(data, key)) {

            if(key === "review" || key === "mappingKey")
                continue
            
            const changeObj = data[key]

            if(Array.isArray(changeObj)) {

                for (let i = 0; i < changeObj.length; i++) {
                    const c = changeObj[i];
                    pushChangeFormItem(key,c)
                }
            } else if(typeof changeObj === 'object') { 
                pushChangeFormItem(key,changeObj)
            }
        }
    }

    // const componentId = "no-data"

    if(elements.length === 0) { 
        elements.push(
        <div key={"data-review-no-data"} className="row bottomMarginNormal bltReviewFormItem">
            <div className={"col-lg-10"}>
                NO DATA
            </div>
        </div>) 
    }

    if(showConfirmation) {
        elements.push(
            <div key={`data-review-confirmation`} className="row bottomMarginNormal bltReviewFormItemConfirmation">
                <div className={"col-lg-10 hideOverflow title"}>
                    <b>{confirmationMessage ? confirmationMessage : `Is this section complete and correct?`}</b>
                </div>
                <div className={"col-lg-2"} style={{textAlign:"end"}}>
                    <button 
                        key={`confirmation-fail`}
                        id={`confirmation-fail`}
                        className={"bltReviewFormItemCheckMark" + (finalConfirmation === "incomplete" ? " bltReviewFormItemCheckMarkFail" : "")} 
                        onClick={() => onConfirmationFail()}
                        disabled={isReadOnly}
                    >
                        <i className="fa fa-2x fa-times-circle"></i>
                    </button>
                    <button
                        key={`confirmation-pass`} 
                        id={`confirmation-pass`}
                        className={"bltReviewFormItemCheckMark" + (finalConfirmation === "complete" ? " bltReviewFormItemCheckMarkPass" : "")} 
                        onClick={() => onConfirmationPass()}
                        disabled={isReadOnly}
                    >
                        <i className="fa fa-2x fa-check-circle"></i>
                    </button>
                </div>
            </div>
        )
    }

    return (
        <div className="bltReviewForm">
           {elements}
        </div>
    )
}

export default BLTChangeReviewForm
